import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApi } from '../base-api';
import { Notification, NotificationListResponse, UnreadCountResponse } from '@app/core/types/notification.types';

@Injectable({
    providedIn: 'root',
})
export class NotificationService extends BaseApi {
    private readonly notificationEndpoint = 'notifications';

    /**
     * Get paginated list of notifications
     */
    getNotifications(page: number = 1, perPage: number = 10): Observable<NotificationListResponse> {
        return this.get<NotificationListResponse>(this.notificationEndpoint, {
            params: { page, per_page: perPage },
        });
    }

    /**
     * Get unread notification count
     */
    getUnreadCount(): Observable<UnreadCountResponse> {
        return this.get<UnreadCountResponse>(`${this.notificationEndpoint}/unread-count`);
    }

    /**
     * Mark a single notification as read
     */
    markAsRead(notificationId: string): Observable<{ message: string }> {
        return this.post<{ message: string }>(`${this.notificationEndpoint}/${notificationId}/mark-as-read`, {});
    }

    /**
     * Mark all notifications as read
     */
    markAllAsRead(): Observable<{ message: string }> {
        return this.post<{ message: string }>(`${this.notificationEndpoint}/mark-all-read`, {});
    }
}
